(function () {
    'use strict';

    a3_cabin_reports.controller('PassengerMealsCtrl', PassengerMealsCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name PassengerMealsCtrl
    * @description 
    *  Manages the Meal Library View
    * @ngInject
    */

    function PassengerMealsCtrl($scope, $routeParams, PassengerMealServiceFactory, FlightMealCriteriaFactory, PaxMealEnums, mealCriteriaIsEnabled) {
        $scope.state = 'mealLibrary'; 
        $scope.selectedService = null;  
        $scope.selectedCycle = null;  
        $scope.filteredMeals = [];  
        $scope.isAllCyclesSelected = false;
        $scope.areAllMealsOpen = false;
        $scope.filteredServices = [];
        $scope.mealServiceSearch = '';
        $scope.mealCriteriaIsEnabled = mealCriteriaIsEnabled;

        $scope.selectService = selectService;
        $scope.filterByCycle = filterByCycle;
        $scope.toggleAllMeals = toggleAllMeals;
        $scope.searchMeals = searchMeals;
        $scope.toggleSidePanel = toggleSidePanel;
        $scope.filterMealServices = filterMealServices;

        //extra filters using ancillaries
        $scope.ancillaries = PassengerMealServiceFactory.getPassengerMealServiceFromStorage();
        $scope.filterByMealCategory = filterByMealCategory;
        $scope.filterByFlightLeg = filterByFlightLeg;
        $scope.filterByCabinClass = filterByCabinClass;
        $scope.filterByServiceZones = filterByServiceZones;
        $scope.filterByMealClass = filterByMealClass;
        $scope.selectedMealCategoryId = null;
        $scope.selectedFlightLegId = null;
        $scope.selectedCabinClassId = null;
        $scope.selectedServiceZone = null;
        $scope.selectedMealClassId = null;

        //When user comes from flight info page with specific flightId
        var paramFlightId = $routeParams.flightId ? $routeParams.flightId : null;
        $scope.criteriaMealType = null;
        $scope.criteriaServiceZone = null;
        $scope.paramMealClassString = $routeParams.mealClass && $routeParams.mealClass !== 'undefined' ? $routeParams.mealClass : null;
        $scope.paramCabinClass = $routeParams.cabinClass && $routeParams.cabinClass !== 'undefined' ? $routeParams.cabinClass : null;
        $scope.paramSearchText = $routeParams.searchText && $routeParams.searchText !== 'undefined' ? $routeParams.searchText : '';
        var paramMealClass = null;
        if ($scope.paramMealClassString) {
            // Map string to enum value
            paramMealClass = PaxMealEnums.MealClass.GetValue($scope.paramMealClassString);
        }
        if($scope.paramCabinClass){
            $scope.selectedCabinClassId = PaxMealEnums.CabinClass.GetValue($scope.paramCabinClass);
        }
        // Pre-fill search if coming from flight info with searchText
        if ($scope.paramSearchText && $scope.paramSearchText.length >= 2) {
            $scope.mealServiceSearch = $scope.paramSearchText;
        }

        $scope.flightMealCriteria = null;
        $scope.preselectedRotation = null;

        if (paramFlightId) {
            $scope.flightMealCriteria = FlightMealCriteriaFactory.getMealCriteriaByFlightIdFromLS(paramFlightId);
        }
        
        // initialize in your controller
        $scope.isCriteriaVisible = true; // start expanded
        $scope.showCriteria = showCriteria;
        $scope.hideCriteria = hideCriteria;
        
        PassengerMealServiceFactory.getPassengerMealServicesFromStorage(function (results) {
            $scope.passengerMeals = results;
            if ($scope.passengerMeals.length > 0) {      
                // Initially, show all services
                $scope.filteredServices = angular.copy($scope.passengerMeals);  
                
                if ($scope.flightMealCriteria) {
                    applyFlightMealCriteria($scope.flightMealCriteria);
                } else {
                    // Default: select the first service if no criteria
                    selectService($scope.passengerMeals[0]);
                }
            }
        });

        // Apply flight meal criteria to pre-select filters and services
        function applyFlightMealCriteria(criteria) {
            //console.log('Applying flightMealCriteria:', criteria);
            const crit = Array.isArray(criteria) ? criteria[0] : criteria;
            if (!crit) return;
            // Meal Type → Meal Category Mapping
            $scope.criteriaMealType = crit.MealType || null;
            $scope.selectedMealCategoryId = PaxMealEnums.Category.GetValue(crit.MealType) || null;

            // Zone → Service Zone
            $scope.selectedServiceZone = crit.Zone || null;
            $scope.criteriaServiceZone = crit.Zone || null;

            // Store preselected rotation for later use
            $scope.preselectedRotation = crit.Rotation ? parseInt(crit.Rotation, 10) : null;

            // Get Meal class from redirect parameters
            $scope.selectedMealClassId = paramMealClass || null;

            // Filter Services Based on Zone + Meal Type
            applyFilters();  

            if($scope.paramSearchText && $scope.paramSearchText.length >= 2){
                $scope.searchText = $scope.paramSearchText;
                searchMeals();
            }
        }

        // Select a service and reset cycles and meals
        function selectService (service) {
            $scope.selectedService = service;  // Set the selected service
            $scope.isAllCyclesSelected = false;
            // Clear the search field when selecting a new service
            $scope.searchText = '';

            if (service.ServiceCycles && service.ServiceCycles.length > 0) {
                // If we have a preselected rotation, try to match it to a cycle
                if ($scope.preselectedRotation) {
                    const rotationNum = $scope.preselectedRotation.toString();
                    const matchedCycle = service.ServiceCycles.find(cycle => {
                        const cycleNum = (cycle.CycleName || '').match(/\d+/);
                        return cycleNum && cycleNum[0] === rotationNum;
                    });

                    if (matchedCycle) {
                        console.log(`Preselecting cycle for rotation ${rotationNum}`);
                        $scope.filterByCycle(matchedCycle);
                        return;
                    }
                }
                // Fallback: select first cycle if no match or no rotation set
                $scope.filterByCycle(service.ServiceCycles[0]);
            } else {
                $scope.selectedCycle = null;
                $scope.filteredMeals = [];
            }

        };

        // Filter meals by cycle when cycle radio button is selected
        function filterByCycle(cycle) {
            $scope.selectedCycle = cycle;
            $scope.isAllCyclesSelected = false; 

            // Clear the search field
            $scope.searchText = '';

            $scope.filteredMeals = cycle.Meals.sort((a, b) => a.MealName.localeCompare(b.MealName));
        };     

        function filterMealServices() { 
           if ($scope.mealServiceSearch && $scope.mealServiceSearch.length >= 2){
            $scope.filteredServices  = $scope.passengerMeals.filter(service => 
                service.ServiceName.toLowerCase().includes($scope.mealServiceSearch.toLowerCase())
            );
           } else{
            $scope.filteredServices = angular.copy($scope.passengerMeals);
           }
        };     

        // Toggle opening/closing all meals
        function toggleAllMeals() {
            $scope.areAllMealsOpen = !$scope.areAllMealsOpen;
            $scope.filteredMeals.forEach(function (meal) {
                meal.isInfoVisible = $scope.areAllMealsOpen;
            });
        };

        // Search meals within the selected service or cycle
        function searchMeals() {
            if ($scope.searchText && $scope.searchText.length >= 2) {
                var searchTextLower = $scope.searchText.toLowerCase();

                // If a specific cycle is selected, filter meals by that cycle
                if ($scope.selectedCycle) {
                    $scope.filteredMeals = $scope.selectedCycle.Meals.map(meal => {
                        var mealNameMatch = meal.MealName.toLowerCase().includes(searchTextLower);

                        // Filter meal items that match search criteria
                        var filteredMealItems = meal.MealItems.map(item => {
                            var itemNameMatch = item.ItemName.toLowerCase().includes(searchTextLower);
                            var allergenMatch = item.Allergen ? item.Allergen.toLowerCase().includes(searchTextLower) : false;
                            var compositionMatch = item.Composition ? item.Composition.toLowerCase().includes(searchTextLower) : false;

                            var matchFound = itemNameMatch || allergenMatch || compositionMatch;
                            item.highlight = matchFound;  // Highlight matched items

                            return item;
                        }).filter(item => item.highlight);

                        // Return the meal if it or its items match the search
                        if (mealNameMatch || filteredMealItems.length > 0) {
                            return {
                                ...meal,
                                MealItems: filteredMealItems,
                                highlight: mealNameMatch
                            };
                        }
                        return null;
                    }).filter(meal => meal !== null);

                // If "All Cycles" is selected, filter meals from all cycles in the selected service
                } else if ($scope.isAllCyclesSelected && $scope.selectedService) {
                    $scope.filteredMeals = $scope.selectedService.ServiceCycles
                        .flatMap(cycle => cycle.Meals.map(meal => {
                            var mealNameMatch = meal.MealName.toLowerCase().includes(searchTextLower);

                            var filteredMealItems = meal.MealItems.map(item => {
                                var itemNameMatch = item.ItemName.toLowerCase().includes(searchTextLower);
                                var allergenMatch = item.Allergen ? item.Allergen.toLowerCase().includes(searchTextLower) : false;
                                var compositionMatch = item.Composition ? item.Composition.toLowerCase().includes(searchTextLower) : false;

                                var matchFound = itemNameMatch || allergenMatch || compositionMatch;
                                item.highlight = matchFound;

                                return item;
                            }).filter(item => item.highlight);

                            if (mealNameMatch || filteredMealItems.length > 0) {
                                return {
                                    ...meal,
                                    MealItems: filteredMealItems,
                                    highlight: mealNameMatch
                                };
                            }
                            return null;
                        }))
                        .filter(meal => meal !== null)
                        .sort((a, b) => a.MealName.localeCompare(b.MealName));  // Sort meals alphabetically
                } else {
                    // If no cycle is selected, reset the meals (optional behavior if needed)
                    $scope.filteredMeals = [];
                }

            } else {
                // If the search text is empty, show all meals for the selected cycle or all cycles
                if ($scope.selectedCycle) {
                    $scope.filteredMeals = $scope.selectedCycle.Meals;
                } else if ($scope.isAllCyclesSelected) {
                    $scope.filteredMeals = $scope.selectedService.ServiceCycles
                        .flatMap(cycle => cycle.Meals)
                        .sort((a, b) => a.MealName.localeCompare(b.MealName));  // Sort meals alphabetically
                } else {
                    $scope.filteredMeals = [];
                }
            }
        }

        function filterByMealCategory(category) {
            if ($scope.selectedMealCategoryId == category.id) {
                $scope.selectedMealCategoryId = null;
            }else{
                $scope.selectedMealCategoryId = category.id;
            };
            applyFilters();
        }

        function filterByFlightLeg(mealClass) {
            if ($scope.selectedFlightLegId == mealClass.id) {
                $scope.selectedFlightLegId = null;
            } else {
                $scope.selectedFlightLegId = mealClass.id;
            };
            applyFilters();
        }   
        
        function filterByCabinClass(cabinClass) {
            if ($scope.selectedCabinClassId == cabinClass.id) {
                $scope.selectedCabinClassId = null;
            } else {
                $scope.selectedCabinClassId = cabinClass.id;
            };
            applyFilters();
            
        }   
        
        function filterByServiceZones(serviceZone) {
            if ($scope.selectedServiceZone == serviceZone) {
                $scope.selectedServiceZone = null;
            } else {
                $scope.selectedServiceZone = serviceZone;
            };
            applyFilters();
            
        }   
        
        function filterByMealClass(mealClass) {
            if ($scope.selectedMealClassId == mealClass.id) {
                $scope.selectedMealClassId = null;
            } else {
                $scope.selectedMealClassId = mealClass.id;
            };
            applyFilters();

        }    

        function applyFilters() {
            $scope.filteredServices = $scope.passengerMeals.filter(service => {
                const matchesCategory = !$scope.selectedMealCategoryId || 
                    (service.MealCategory && (
                        service.MealCategory === $scope.selectedMealCategoryId ||
                        service.MealCategory === PaxMealEnums.Category.GetValue('Both')
                    ));

                const matchesMealClass = !$scope.selectedMealClassId || 
                    (service.MealClass && service.MealClass === $scope.selectedMealClassId);

                const matchesFlightLeg = !$scope.selectedFlightLegId ||
                    (service.FlightLeg && (
                        service.FlightLeg === $scope.selectedFlightLegId ||
                        service.FlightLeg === PaxMealEnums.FlightLeg.GetValue('Both')
                    ));

                const matchesCabinClass = !$scope.selectedCabinClassId || 
                    (service.CabinClass && service.CabinClass === $scope.selectedCabinClassId);

                const matchesServiceZone = !$scope.selectedServiceZone || 
                    (service.ServiceZone && service.ServiceZone === $scope.selectedServiceZone);

                return matchesCategory &&
                    matchesMealClass &&
                    matchesFlightLeg &&
                    matchesCabinClass &&
                    matchesServiceZone;
            });
        }

        // Toggle visibility of meal details
        $scope.toggleVisibility = function (meal) {
            meal.isInfoVisible = !meal.isInfoVisible;
        };
    
        function toggleSidePanel() {
            $scope.shownSideMenu = !$scope.shownSideMenu;
        }

        function showCriteria() {
        $scope.isCriteriaVisible = true;
        };

        function hideCriteria() {
        $scope.isCriteriaVisible = false;
        };


    }
})();